import {
  colorContentDim,
  colorOutlineDefault,
} from '@duxton-web/design-tokens/themes/light';
import { CopyOutlined } from '@duxton-web/icons';
import { Button, Flex, List } from '@duxton-web/ui';
import React, { useMemo, useState } from 'react';

import SmartCampaignDynamicAttributesModal from 'omega-rtc/components/form/ucd/SmartCampaignDynamicAttributesModal';
import { DYNAMIC_ATTRIBUTES_VALUE_TO_LABEL_MAP } from 'omega-rtc/constants/ucd';
import {
  copyTextToClipBoard,
  getAdditionalInfoOfDynamicAttributes,
} from 'omega-rtc/utils/smart-campaign-utils';

const SmartCampaignDynamicAttributesCard = ({ dynamicAttribute }) => {
  const [attributeModalInfo, setAttributeModalInfo] = useState({
    isModalOpen: false,
    selectedAttribute: '',
  });

  // TODO: Modal functionality is temporarily disabled
  // const showModal = (attribute) => {
  //   setAttributeModalInfo((previousState) => ({
  //     ...previousState,
  //     isModalOpen: true,
  //     selectedAttribute: attribute,
  //   }));
  // };

  const formattedAttribute = useMemo(() =>
    dynamicAttribute.map(
      (value) => DYNAMIC_ATTRIBUTES_VALUE_TO_LABEL_MAP[value],
    ),
  );

  return (
    <React.Fragment>
      <List
        size="small"
        dataSource={formattedAttribute}
        style={{ marginBottom: 16 }}
        split={false}
        renderItem={(item) => (
          <List.Item
            key={item}
            style={{
              border: `1px solid ${colorOutlineDefault}`,
              marginBottom: 8,
              borderRadius: 16,
            }}
            actions={[
              // TODO: Modal preview icon is temporarily hidden
              // <Button
              //   type="secondary"
              //   size="small"
              //   shape="circle"
              //   icon={<ShowOutlined />}
              //   onClick={() => showModal(item)} // Show modal by clicking the button
              // />,
              <Button
                type="secondary"
                size="small"
                shape="circle"
                icon={<CopyOutlined />}
                onClick={() => {
                  copyTextToClipBoard(`{${item}}`); // To copy the text to clipboard
                }}
              />,
            ]}
          >
            <List.Item.Meta
              title={<span style={{ fontWeight: 400 }}>{item}</span>}
              description={
                <Flex vertical>
                  <span
                    style={{
                      color: colorContentDim,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      fontSize: 12,
                    }}
                  >
                    {getAdditionalInfoOfDynamicAttributes(item).content}
                  </span>
                  {/* TODO: "Last update" display is temporarily hidden */}
                  {/* <span style={{ color: colorContentDim, fontSize: 10 }}>
                    {`Last update: ${getAdditionalInfoOfDynamicAttributes(item).lastUpdatedTime}`}
                  </span> */}
                </Flex>
              }
            />
          </List.Item>
        )}
      />
      {/* Modal to show the attributes dataset */}
      <SmartCampaignDynamicAttributesModal
        setAttributeModalInfo={setAttributeModalInfo}
        attributeModalInfo={attributeModalInfo}
      />
    </React.Fragment>
  );
};

export default SmartCampaignDynamicAttributesCard;
